<template>
  <IonModal ref="modal">
    <IonHeader>
      <IonToolbar>
        <IonTitle>{{ title || 'Photo' }}</IonTitle>
        <IonButtons slot="end">
          <IconButton @click="dismiss" icon="icon-x" />
        </IonButtons>
      </IonToolbar>
    </IonHeader>
    <IonContent>
      <img :src="base64 ? `data:image/jpeg;base64, ${base64}` : photo?.url" alt="" />
      <div class="p-4">
        <div v-if="photo?.createdAt" class="text-gray-500 font-medium">
          <div class="text-sm">PHOTO BY</div>
          <div class="text-gray-700 font-semibold">
            {{ photo?.createdBy }}
          </div>
          <div v-if="photo?.createdAt">
            {{ formatTimeAgo(photo.createdAt) }}
          </div>
        </div>
        <LightBlockButton class="mt-4" :disabled="isUploading" @click="$emit('takePhoto')">
          <div class="flex items-center" v-if="!isUploading">
            <i class="icon-camera mr-2 text-blue-500"></i>
            Retake Photo
          </div>
          <div v-else class="flex items-center">
            <IonSpinner class="mr-1" name="lines-small" color="primary"></IonSpinner>
            Uploading
          </div>
        </LightBlockButton>
      </div>
    </IonContent>
  </IonModal>
</template>

<script setup lang="ts">
import IconButton from '@/components/forms/IconButton.vue';
import { IonModal, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonSpinner } from '@ionic/vue';
import { ref } from 'vue';
import { IDocument } from '@ncss/models';
import { formatTimeAgo } from '@vueuse/core';
import LightBlockButton from '@/components/forms/LightBlockButton.vue';

const modal = ref<InstanceType<typeof IonModal>>();

defineProps<{
  title?: string;
  photo?: IDocument;
  base64?: string;
  isUploading?: boolean;
}>();
defineEmits<{
  (e: 'takePhoto'): void;
}>();

function present() {
  modal.value?.$el.present();
}

function dismiss() {
  modal.value?.$el.dismiss();
}

defineExpose({
  present,
  dismiss,
});
</script>
